export class Participante {

  Id: number;
  TipoPessoa: string;
  Ativo: boolean;
  NomeFantasia: string;
  RazaoSocial: string;
  CNPJ_CPF: string;
  IE_RG: string;
  RGDataExpedicao: Date;
  RGOrgaoExpedidor: string;
  PIS: string;
  DataNascimento: Date;
  Sexo: string;
  EstadoCivil: string;
  Conjuge: string;
  Endereco: string;
  EnderecoNumero: string;
  EnderecoComplemento: string;
  Bairro: string;
  CEP: string;
  CidadeId: number;
  Contato: string;
  Telefone: string;
  Celular: string;
  Fax: string;
  Email: string;
  Site: string;
  Pai: string;
  Mae: string;
  Empresa: string;
  EmpresaTelefone: string;
  EmpresaContato: string;
  CTPS: string;
  CTPSSerie: string;
  Profissao: string;
  Observacao: string;
  Apelido: string;
  PaisCelular: string;
  
  DataAlteracao: Date;

  Cliente: boolean;
  Fornecedor: boolean;
  Parceiro: boolean;
  AdvogadoParceiro: boolean;
  ParteContraria: boolean;
  Funcionario: boolean;
  Advogado: boolean;
  Estagiario: boolean;

  UsuarioTipoId: number;
  UnidadeId: number;
  Foto: string;
  constructor() { }
}

export class ParticipanteLista {

  Id: number;
  NomeFantasia: string;
  RazaoSocial: string;
  CNPJ_CPF: string;
  Cidade: string;
  Telefone: string;
  Celular: string;
  Email: string;
  Ativo: boolean;

  constructor() { }
}

export class ParticipanteListaFiltros {

  constructor() {
    this.ativo = true;
    this.cliente = false;
    this.fornecedor = false;
    this.parceiro = false;
    this.parteContraria = false;
    this.advogadoParceiro = false;
    this.buscaTexto = '';
  }
  
  cliente: boolean;
  fornecedor: boolean;
  parceiro: boolean;
  parteContraria: boolean;
  advogadoParceiro: boolean;
  buscaTexto: string;
  buscaTipo: string;
  tipo: any;
  ativo: boolean;
}
